import React from 'react';
import { ComponentPropsWithoutRef } from 'react';

import { CommonFormComponentProps } from '../types/components';
import Dropdown from './Dropdown';
import FieldLabel from './FieldLabel';
import FieldStatusText from './FieldStatusText';
import FormGroup from './FormGroup';

type Props = CommonFormComponentProps & ComponentPropsWithoutRef<typeof Dropdown>;

const FormDropdown: React.FC<Props> = ({ label, error, ...props }) => (
    <FormGroup itemsSpacing={5}>
        <FieldLabel>{label}</FieldLabel>
        <Dropdown {...props} onClose={() => {}} />
        <FieldStatusText status="error">{error}</FieldStatusText>
    </FormGroup>
);

export default FormDropdown;
